import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, Component, useRef, useEffect, useState } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap"

import { Tooltip } from "reactstrap"

import moment from "moment"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { Link } from 'react-router-dom'

import Select from "react-select"
import YearSelect from '../../../../helpers/ui/YearSelect';
import Shimmer from "react-shimmer-effect";
import classnames from "classnames"

import TableComponent from './Components/TableComponent'
import TableSecondComponent from "./Components/TableSecondComponent"
import TableBKNComponent from "./Components/TableBKNComponent"
import IndexBloc from '../Pegawai/Blocs/IndexBloc'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0' + dt

    return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
};

const PegawaiView = (props) => {

    const indexBloc = new IndexBloc()

    const [activeTab, setactiveTab] = useState("1")
    const activeRef = useRef();
    const inactiveRef = useRef();
    const [period, setPeriod] = useState()


    const secondaryRef = useRef();
    const exportExcel = () => activeRef.current.exportExcel()

    function handleButtonExport() {
        // alert('aaaaaaaaa')
        exportExcel()
    }


    useEffect(() => {
        indexBloc.fetchDetailPeriode({ uuid: props.uuid })
        indexBloc.detailPeriodeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    setPeriod(result.data.response)
                    break;
                default:
                    break;
            }
        })
        return () => {
            indexBloc.detailPeriodeChannel?.unsubscribe()
        }
    }, [])

    const reloadSecondaryRef = () => secondaryRef.current.setTokenAPI()


    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <CardTitle>Daftar Pegawai Rapel Keuangan</CardTitle>
                        <CardSubtitle className="mb-3">
                            {/* Daftar Urut Kepangkatan */}
                        </CardSubtitle>
                        <hr />
                        <div className="float-end">
                            {
                                (accessRole('create')) ?
                                    <Button
                                        color="success"
                                        type="button"
                                        onClick={() => {
                                            handleButtonExport()
                                        }}
                                    >
                                        Export Revisi
                                    </Button>
                                    : null
                            }
                            {' '}
                            {

                                period?.period_financial_revision_status == 0 ?
                                    <>
                                        <Link to={`?addpegawai&uuid=` + props.uuid}>
                                            <Button color="primary">Tambah Pegawai</Button>
                                        </Link>
                                    </>
                                    : ''
                            }
                        </div>
                        <Row className="mb-3">
                            <Label className="col-md-2 col-form-label">Periode :</Label>
                            <Label className="col-md-6 col-form-label">{period ? period?.period_financial_revision_periode : '-'}</Label>
                        </Row>
                        <hr />
                        <TableComponent ref={activeRef} handleProcessSuccess={reloadSecondaryRef} uuid={props.uuid} periode_name={period ? period?.period_financial_revision_periode : '-'} periode_status={period ? period?.period_financial_revision_status : '0'} />
                        <div>
                            <Link to='/kepegawaian/revisi_keuangan.html'>
                                <Button color="success"><i className="uil-backspace"></i> Kembali</Button>
                            </Link>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>

    )
}

export default PegawaiView